/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_IntroInputs */

const en_us2_invite_intro = /** @type {(inputs: Invite_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your invite is a code of your own. Whoever joins with it shows up in your count. No prize and no ranking: it is just so you know who came.`)
};

const pt_br2_invite_intro = /** @type {(inputs: Invite_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu convite é um código só seu. Quem entrar com ele aparece na sua contagem. Sem prêmio e sem ranking: é só para você saber quem veio.`)
};

const pt_pt2_invite_intro = /** @type {(inputs: Invite_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu convite é um código só seu. Quem entrar com ele aparece na sua contagem. Sem prêmio e sem ranking: é só para você saber quem veio.`)
};

/** @type {(inputs: Invite_IntroInputs) => LocalizedString} */
const es_419_invite_intro = en_us2_invite_intro;

/** @type {(inputs: Invite_IntroInputs) => LocalizedString} */
const fr_fr2_invite_intro = en_us2_invite_intro;

/** @type {(inputs: Invite_IntroInputs) => LocalizedString} */
const de_de2_invite_intro = en_us2_invite_intro;

/** @type {(inputs: Invite_IntroInputs) => LocalizedString} */
const it_it2_invite_intro = en_us2_invite_intro;

/**
* | output |
* | --- |
* | "Your invite is a code of your own. Whoever joins with it shows up in your count. No prize and no ranking: it is just so you know who came." |
*
* @param {Invite_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_intro = /** @type {((inputs?: Invite_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_intro(inputs)
	if (locale === "es-419") return es_419_invite_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_intro(inputs)
	if (locale === "de-DE") return de_de2_invite_intro(inputs)
	if (locale === "it-IT") return it_it2_invite_intro(inputs)
	return en_us2_invite_intro(inputs)
});
export { invite_intro as "invite.intro" }